import { Button, Flex, Icon, useBreakpointValue } from "@chakra-ui/react";
import { BlockHeader } from "../BlockHeader";
import { t } from "i18next";
import { FaFileImport, FaDownload } from "react-icons/fa";
import { FormInput } from "../Forms";
import * as React from "react";

function ScopeHeaderRow({ title, description, importBtnId, handleDataImport, isPreview, handleTemplateDownload }) {
  const templateBtnWidth = useBreakpointValue({
    base: "34",
    md: "48"
  });
  const importBtnWidth = useBreakpointValue({
    base: "28",
    md: "32"
  });
  const btnFontSize = useBreakpointValue({
    base: "sm",
    md: "md"
  });
  const containerDisplay = useBreakpointValue({
    base: "block",
    md: "flex"
  });

  const handleImportDataClick = () => {
    const importBtn = document.getElementById(importBtnId);
    if (importBtn) {
      importBtn.click();
    }
  };

  return (
    <Flex flexDir="column" paddingBlock="6">
      <Flex gap={10} justifyContent="space-between" display={containerDisplay}>
        <BlockHeader title={title} description={description} marginBottom={containerDisplay === "block" ? 5 : 0} />
        {!isPreview && <Flex gap={4}>
          <Button
            colorScheme="white"
            color="esg_lightgreen"
            border={"1px solid"}
            borderColor={"esg_lightgreen"}
            width={templateBtnWidth}
            fontSize={btnFontSize}
            onClick={() => handleTemplateDownload()}
          >
            <Icon
              as={FaDownload}
              inlineSize="3"
              blockSize="3"
              color="esg_green"
              marginEnd="2"
              marginTop={containerDisplay === "block" ? "0" : "1"}
            />
            {t("organizationQuestionnaire.scope1.inputs.downloadTemplate")}
          </Button>
          {importBtnId && <FormInput
            id={importBtnId}
            name={importBtnId}
            type="file"
            onChange={(e) => handleDataImport(e, importBtnId)}
            paddingInlineStart="0"
            border="none"
            accept={".xlsx, .xls"}
            controlProps={{ display: "none" }}
          />}
          <Button
            colorScheme="white"
            color="esg_lightgreen"
            border={"1px solid"}
            borderColor={"esg_lightgreen"}
            width={importBtnWidth}
            fontSize={btnFontSize}
            onClick={handleImportDataClick}
          >
            <Icon
              as={FaFileImport}
              inlineSize="3"
              blockSize="3"
              color="esg_green"
              marginEnd="2"
              marginTop={containerDisplay === "block" ? "0" : "1"}
            />
            {t("organizationQuestionnaire.scope1.inputs.importData")}
          </Button>
        </Flex>
        }
      </Flex>
    </Flex>
  );
}

export default ScopeHeaderRow;
